export const tuple = <A, B>(a: A, b: B): [A, B] => [a, b]
